import { atom } from 'recoil';

// 쉬운 코드(카포) 적용 상태. base = 카포를 끼우기 전의 baseKey (원래대로 돌릴 때 사용)
export default atom<{ capo: number; base: number } | null>({
  key: 'capo',
  default: null,
});
